import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
function StarRating() {
  return <div className="flex items-center gap-1 mb-5" aria-label="5 de 5 estrellas" data-id="element-299">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-300" />)}
    </div>;
}
export function Testimonials() {
  const testimonials = [{
    initials: 'MP',
    quote: 'Organicé todo el mes en una tarde. Nunca más llego a práctica sin saber qué ejercicio dar.',
    name: 'Marcos P., Buenos Aires',
    role: 'Entrenador de Club de Barrio'
  }, {
    initials: 'CG',
    quote: 'Mis nenas de 9na mejoraron el push desde la primera semana con el Tomo 3.',
    name: 'Carolina G., Córdoba',
    role: 'Entrenadora en Club Privado'
  }, {
    initials: 'FR',
    quote: 'Antes tardaba 1 hora armando la clase. Ahora son 5 minutos.',
    name: 'Fernando R., Rosario',
    role: 'Entrenador Independiente'
  }];
  return <section className="bg-[#F9F9F9] py-16 px-4" data-id="element-301">
      <div className="max-w-6xl mx-auto" data-id="element-302">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-303">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-304">
              <StarRating data-id="element-305" />
              <div className="w-16 h-16 bg-[#0284C7]/10 text-[#0284C7] rounded-full flex items-center justify-center text-xl font-bold mb-6" data-id="element-306">
                {t.initials}
              </div>
              <p className="text-gray-700 italic text-lg mb-6 flex-grow" data-id="element-307">
                "{t.quote}"
              </p>
              <div data-id="element-308">
                <p className="font-bold text-gray-900" data-id="element-309">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-310">{t.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}